/**
 *
 * ServiceRequestsManagerCompleteFormDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';

import { SERVICE_REQUESTS_MANAGER_COMPLETE_FORM, SERVICE_REQUESTS_MANAGER_COMPLETE_FORM_DIALOG } from './constants';

function ServiceRequestsManagerCompleteFormDialog({ form }) {
  return (
    <AdvancedFormDialog
      name={SERVICE_REQUESTS_MANAGER_COMPLETE_FORM_DIALOG}
      formName={SERVICE_REQUESTS_MANAGER_COMPLETE_FORM}
      advancedForm={form}
      editModeTitle="Заявка выполнена"
    />
  );
}

ServiceRequestsManagerCompleteFormDialog.propTypes = {
  form: PropTypes.node.isRequired,
};

export default ServiceRequestsManagerCompleteFormDialog;
